import * as React from 'react';
import {Mutation} from 'react-apollo';

import {CheckboxButton} from 'shells/button/checkbox-button/checkbox-button';

import type {
    Lead as LeadFragment,
    UpdateLeadCustomFieldValue as UpdateLeadCustomFieldValueMutation,
    UpdateLeadCustomFieldValueVariables as UpdateLeadCustomFieldValueMutationVariables,
} from 'nutshell-graphql-types';

import UPDATE_LEAD from '../../../shared/graphql/mutations/update-lead-custom-field-value.graphql';

class UpdateLeadMutation extends Mutation<
    UpdateLeadCustomFieldValueMutation,
    UpdateLeadCustomFieldValueMutationVariables
> {}

type Props = {
    lead: LeadFragment;
};

export function HotButton(props: Props) {
    return (
        <UpdateLeadMutation
            mutation={UPDATE_LEAD}
            onCompleted={() => {
                Timeline.refreshTimeline();
            }}
        >
            {(updateLead, {loading}) => (
                <CheckboxButton
                    label='Hot'
                    disabled={loading}
                    checked={props.lead.isHot}
                    onChange={(isChecked) => {
                        const priority = isChecked ? 'HOT' : 'NORMAL';

                        updateLead({
                            variables: {lead: {id: props.lead.id, priority: priority}},
                            optimisticResponse: {
                                // @ts-expect-error
                                __typename: 'Mutation',
                                updateLead: {
                                    __typename: 'UpdateLeadPayload',
                                    lead: {
                                        // @ts-expect-error
                                        __typename: 'Lead',
                                        ...props.lead,
                                        priority: priority,
                                    },
                                },
                            },
                        });
                    }}
                />
            )}
        </UpdateLeadMutation>
    );
}
